import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMenu } from './useMenu';

export interface RequireMenuProps {
  menu: string;
  redirectTo?: string;
  children: React.ReactNode;
}

export function RequireMenu({ menu, redirectTo = '/forbidden', children }: RequireMenuProps) {
  const allowed = useMenu(menu);
  if (!allowed) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}
